import { Box, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { FC } from 'react';
import { IShift } from '../../routes/board-slips/BoardSlipsData';
import { SlipComp } from './SlipComp';
import { countRowStyle, descRowStyle, noSlipsStyle, slipsRowStyle } from './styled';

export const SlipsTable: FC<Record<"shift", IShift>> = ({ shift }) => {
  return (
    <Box>
      {shift.shiftDescription ? <Typography sx={descRowStyle}>{shift.shiftDescription}</Typography> : null}
      <Box sx={{ width: '100%', overflow: 'auto' }}>
        <Table>
          <TableBody>
            <TableRow sx={slipsRowStyle}>
              {
                shift.slips?.length ? shift.slips.map((slip, i) => (
                  <TableCell sx={{ p: 1 }} key={i}>
                    <SlipComp slip={slip} />
                  </TableCell>
                )) : (
                  <TableCell colSpan={shift.slipsCount}>
                    <Typography sx={noSlipsStyle}>
                      No Slips available for the {shift.shiftDescription ? shift.shiftDescription : 'shift'}
                    </Typography>
                  </TableCell>
                )
              }
            </TableRow>
          </TableBody>
        </Table>
      </Box>
      <Typography sx={countRowStyle}>Slip Count: {shift.slipsCount}</Typography>
    </Box>
  )
}